import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { BehaviorSubject, Observable } from 'rxjs';
import { CompanyDebtorMinuteRequestResolutionDTO, MinuteRequestDetailRealTimeDTO } from '../interface/minute-detail';
import { environment } from 'src/environments/enviroments';

@Injectable({
  providedIn: 'root'
})
export class RealTimeMinuteService {
  private hubConnection: HubConnection;

  private receivedMinuteDetailSubject = new BehaviorSubject<MinuteRequestDetailRealTimeDTO>(null);
  public receivedMinuteDetai$ = this.receivedMinuteDetailSubject.asObservable();

  private receivedMinuteDebtorResolutionsSubject = new BehaviorSubject<Array<CompanyDebtorMinuteRequestResolutionDTO>>([]);
  public receivedMinuteDebtorResolutions$ = this.receivedMinuteDebtorResolutionsSubject.asObservable();

  private loadingMinuteSubject = new BehaviorSubject<boolean>(false);
  public loadingMinute$: Observable<boolean> = this.loadingMinuteSubject.asObservable();

  private isConnected : boolean = false;

  constructor() { }

  public startConnection(minuteRequestId: number): Promise<void> {
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(`${environment.apiUrl}/hubs/minute-request`, { withCredentials: false })
      .build();

    return this.hubConnection.start()
      .then(() => {
        this.loadingMinuteSubject.next(true);
        console.log("SignalR connection started");
        console.log("Joining group: " + minuteRequestId);
        this.joinGroup(minuteRequestId);
        this.getMinuteDetail();
        this.getMinuteDebtorResolutions();
        this.isConnected = true;
      })
      .catch((err) => {
        console.log("Error starting connection" + err);
        this.loadingMinuteSubject.next(false);
        throw err; // Re-throw error to handle it in the component
      });
  }

  public stopConnection() {
    if(this.isConnected) {
      this.hubConnection.stop()
      .then(() => {
        console.log('SignalR connection stopped');
        this.isConnected = false;
      })
    }
  }

  private getMinuteDetail(): void {
    this.hubConnection.on('ReceiveMinuteRequestDetail', (minute: MinuteRequestDetailRealTimeDTO) => {
      this.receivedMinuteDetailSubject.next(minute);
    })
  }

  private getMinuteDebtorResolutions(): void {
    this.hubConnection.on('ReceiveMinuteRequestDebtorResolutions', (debtorResolutions: Array<CompanyDebtorMinuteRequestResolutionDTO>) =>{
      this.receivedMinuteDebtorResolutionsSubject.next(debtorResolutions);
    });
  }

  private joinGroup(minuteRequestId: number) {
    this.hubConnection.invoke('JoinGroup', minuteRequestId)
    .then(() => console.log(`Joined group: ${minuteRequestId}`))
    .catch((err) => console.error(`Error while joining group: ${err}`))
  }

  public getMinuteRequestDetail(minuteRequestId: number) {
    this.hubConnection.invoke("Join", minuteRequestId);
    this.hubConnection.invoke("GetMinuteRequestDetail", minuteRequestId);
  }
}
